// apps/dashboard/src/api/transforms/briefAnalysis.ts
import type { BriefProjection, BriefAnalysisFormState } from "../types";

// Pure transform from the server-side projection (BriefProjection) to the client-side
// form state (BriefAnalysisFormState). Differences:
//   1. _id renamed to briefId for hook return-type consistency.
//   2. Optional fields (constraints, preSeedInputs) normalized to empty string for
//      uniform <TextArea> binding. React's controlled-component contract requires
//      the value prop to be a defined string, not undefined.
export function transformBriefAnalysis(projection: BriefProjection): BriefAnalysisFormState {
  return {
    briefId:         projection._id,
    repositoryId:    projection.repositoryId,
    objective:       projection.objective,
    audience:        projection.audience,
    constraints:     projection.constraints   ?? "",
    successCriteria: projection.successCriteria,
    preSeedInputs:   projection.preSeedInputs  ?? "",
    updatedAt:       projection.updatedAt,
  };
}
